import { ArrowUpRight, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { ToolDefinition } from '../domain/tools/types';
import { localize } from '../domain/tools/types';
import { useLanguage } from '../features/language/useLanguage';
import { ToolIcon } from './ToolIcon';

interface ToolCardProps {
  readonly tool: ToolDefinition;
  readonly favorite: boolean;
  readonly onToggleFavorite: (id: ToolDefinition['id']) => void;
}

export function ToolCard({ tool, favorite, onToggleFavorite }: ToolCardProps) {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const name = localize(tool.name, language);

  return (
    <article className="tool-card" data-category={tool.category}>
      <Link className="tool-card-main" to={tool.route} aria-label={name}>
        <span className="tool-icon"><ToolIcon tool={tool.id} /></span>
        <span>
          <h3>{name}</h3>
          <p>{localize(tool.description, language)}</p>
        </span>
      </Link>
      <div className="tool-card-footer">
        <small>{tool.multipleFiles ? t('toolLibrary.multipleFiles') : t('toolLibrary.worksOffline')}</small>
        <button
          className={`icon-button favorite-button${favorite ? ' is-active' : ''}`}
          type="button"
          aria-label={favorite ? t('home.removeFavorite', { tool: name }) : t('home.addFavorite', { tool: name })}
          aria-pressed={favorite}
          onClick={() => onToggleFavorite(tool.id)}
        >
          <Star size={17} fill={favorite ? 'currentColor' : 'none'} aria-hidden="true" />
        </button>
        <ArrowUpRight className="sr-only" aria-hidden="true" />
      </div>
    </article>
  );
}
